import { z } from 'zod';
import { ActionSchema } from '../actions';

export const FormBlockSchema = z.object({
  id: z.string().min(1),
  type: z.literal('form'),
  rect: z.object({
    x: z.number().int().nonnegative(),
    y: z.number().int().nonnegative(),
    w: z.number().int().positive(),
    h: z.number().int().positive()
  }),
  on: z.object({ tap: z.array(ActionSchema).optional() }).optional(),
  props: z.object({
    form_id: z.string().min(1),
    submit_label: z.string().min(1),
    fields: z.array(z.object({
      id: z.string().min(1),
      label: z.string().min(1),
      type: z.enum(['text', 'email', 'phone', 'select', 'host']),
      required: z.boolean(),
      options: z.array(z.string()).optional()
    }))
  })
});